import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { bookNumberMask, objectToQueryString } from "../../../../Helpers/utils/utils";
import {
  getSchoolReturnsByIdRequest,
  getSummaryRequest,
} from "../../../../Backend/SchoolsRequests";
import { hasValue } from "../../../../Helpers/validations/common";
import { PackageStatusCell } from "../../../../Components/PackageStatusCell/PackageStatusCell";
import "./SummarySchool.scss";

export function SummarySchool() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [errorSummary, setErrorSummary] = useState(false);

  const [school, setSchool] = useState({
    id: "",
    year: 0,
    completed: false,
    schoolId: "",
    school: {
      id: "",
      schoolNumber: 0,
      name: "",
      digiDeliveryId: "",
      schoolDeliveryType: "",
      studentCount: 0,
    },
  });

  const [barcodes, setBarcodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hasValue(id)) {
      getSchoolById();
    }
  }, [id]);

  const getSchoolById = async () => {
    setLoading(true);
    const resp = await getSchoolReturnsByIdRequest(id);

    if (resp.success) {
      const schoolData = resp.data.list[0];
      setSchool(schoolData);
      getSummary(schoolData.school.id, schoolData.year);
    }
  };

  const getSummary = async (schoolId, year) => {
    const params = {
      schoolId: schoolId,
      year: year,
    };

    var data = await getSummaryRequest(objectToQueryString(params, true));

    if (data.success) {
      setBarcodes(data.data);
      setErrorSummary(false);
      setLoading(false);
    } else {
      setErrorSummary(true);
      setLoading(false);
    }
  };

  const renderItems = (startIdx, endIdx) => {
    let html = [];
    const maxIdx = barcodes.length > endIdx ? endIdx : barcodes.length;
    for (let index = startIdx; index < maxIdx; index++) {
      const barcode = barcodes[index];

      const booksHtml = [];

      booksHtml.push(
        <div className="book-wrapper" key={"book-" + index}>
          <div className="book-number-header">#</div>
          <div className="book-title-header">{t("Title")}</div>
          <div className="book-isbn-header">{t("ISBN")}</div>
          <div className="book-delivered-header">{t("Delivered")}</div>
          <div className="book-status-header">{t("Status")}</div>
        </div>
      );

      barcode.barcodeBookScanResourceList.map((book, i) => {
        booksHtml.push(renderBook(book, i));
      });

      html.push(
        <div className={"barcode"} key={"barcode-" + index}>
          <div className="title-wrapper">
            <div className="title">
              <span className="student-name">
                {`${barcode.barcodeBookResource.student.firstName} ${barcode.barcodeBookResource.student.preposition} ${barcode.barcodeBookResource.student.lastName}`}
              </span>
              <span className="barcode-code">{`${barcode.barcodeBookResource.barcode}`}</span>
            </div>
            <PackageStatusCell
              status={barcode.barcodeBookResource.schoolScanComplete}
            />
          </div>
          <div className="body-wrapper">{booksHtml}</div>
        </div>
      );
    }

    return html;
  };

  const renderBook = (book, idx) => {
    return (
      <div className="book-wrapper" key={"bookinfo-" + idx}>
        <div title={book.book.bookNumber} className="book-number">
          {bookNumberMask(book.book.bookNumber)}
        </div>
        <div title={book.book.title} className="book-title">
          {book.book.title}
        </div>
        <div title={book.book.isbn} className="book-isbn">
          {book.book.isbn}
        </div>
        <div
          title={book.schoolScan ? t("Delivered") : t("NotDelivered")}
          className="book-delivered"
        >
          {book.schoolScan ? "check_box" : "check_box_outline_blank"}
        </div>
        <div
          title={book.schoolSuitable ? t("Suitable") : t("NotSuitable")}
          className="book-status"
        >
          {book.schoolSuitable ? t("Suitable") : t("NotSuitable")}
        </div>
      </div>
    );
  };

  const render = () => {
    return (
      <div className="page-wrapper">
        <div className="info-wrapper">
          <div className="left-wrapper">
            <span className="title">{t("Information")}</span>
            {info.map((x) => (
              <div className="info-row" key={"info-" + x.key}>
                <span className="key">{x.key}:</span>
                <span className="value">{x.value}</span>
              </div>
            ))}
          </div>
        </div>
        {renderItems(0, barcodes.length)}
      </div>
    );
  };

  const info = [
    { key: t("SchoolNumber"), value: school.school.schoolNumber },
    { key: t("Name"), value: school.school.name },
    { key: t("SchoolType"), value: school.school.schoolDeliveryType },
    { key: t("StudentsCount"), value: barcodes.length },
  ];

  return (
    <div className="summary-school trans-fromTop">
      <div className="print-wrapper">
        <header className="header">
          <div className="img-wrapper">
            <img src="/InleverWhiteIcon.svg" alt="image" />
            <img className="pt-1" src="/InleverWhiteLogo.svg" alt="image" />
          </div>
          <div className="user-info">
            <div className="title-summary">{t("Summary")}</div>
          </div>
        </header>
        <main className="main">
          <div className="buttons-wrapper no-print">
            <div
              className="goback outlined"
              onClick={() => navigate(-1)}
              role="link"
              id={"goback-button"}
            >
              <div className="text">{t("GoBack")}</div>
            </div>
            <div
              className="goback"
              onClick={() => window.print()}
              role="link"
              id={"goback-button"}
            >
              <div className="text">{t("Print")}</div>
            </div>
          </div>
          {loading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : errorSummary === false ? (
            render()
          ) : (
            <div className="error-summary-wrapper">
              {t("ErrorSummaryMessage")}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
